import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=49b90b06"
var script = {}
import style0 from "./Login.vue?vue&type=style&index=0&id=49b90b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports